import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Page } from '@components/page';
import { ExclamationCircleOutlined, LeftOutlined } from '@ant-design/icons';
import { SelectItemsHeader } from './components/select-items-header';
import {
    SelectItemsBody,
    SelectItemsBodyBonification,
} from './components/select-items-body';
import { SelectItemsActions } from './components/select-items-actions';
import { useDispatch, useSelector } from 'react-redux';
import {
    bonificationSelector,
    fetchAvailableItems,
    orderItemsSelector,
    resetAvailableItems,
    updateCampaignItems,
} from '@redux/slices/order';
import { Tabs } from '@components/tabs/styled';
import { useQuery as useQueryHooks } from '@hooks/use-query';
import { Col, Modal, Row } from 'antd';
import { Semaphore } from '@components/semaphore';
import { OrderContextProvider } from './context/provider';
import { OrderContext } from './context/context';
import { clearMinOrderState } from '@redux/slices/min-order';
import { translate } from '@components/i18n';
import { AppDispatch } from '@redux/store';
import { updatePaymentCondition } from '@redux/slices/order/select-items';

const { TabPane } = Tabs;
const { confirm } = Modal;

export const Bonification: React.FC = () => {
    return (
        <OrderContextProvider>
            <BonificationContent />
        </OrderContextProvider>
    );
};

const BonificationContent: React.FC = () => {
    const { selectedOrders } = useSelector(bonificationSelector);
    const { order, paymentCondition, selectedMoeda, ...selectItemsState } = useSelector(orderItemsSelector);
    const dispatch = useDispatch<AppDispatch>();
    const query = useQueryHooks();
    const history = useHistory();
    const { setCanLeave } = useContext(OrderContext);
    const [loading, setLoading] = useState<boolean>(true)

    // Botão voltar: confirma e vai pra home via SPA (history.push). Bypassa o
    // <Prompt> de SelectItemsActions via setCanLeave — sem isso, o usuário leva
    // dois diálogos seguidos.
    const handleBackToHome = (): void => {
        confirm({
            title: translate('general.wantToBackToHome'),
            icon: <ExclamationCircleOutlined />,
            className: 'confirm-modal-styled',
            okText: translate('general.no'),
            okType: 'danger',
            cancelText: translate('general.yes'),
            okButtonProps: { type: 'primary' },
            cancelButtonProps: { type: 'primary', className: 'green-btn' },
            onOk() {
                // permanece na tela
            },
            onCancel() {
                setCanLeave(() => history.push('/'));
            },
        });
    };

    const fetchPreData = async (): Promise<void> => {
        await Promise.all([
            dispatch(clearMinOrderState()),
            dispatch(resetAvailableItems()),
        ])
    }

    useEffect(() => {
        dispatch(updatePaymentCondition({
            id: "100",
            description: ""
        }))
    }, [])

    useEffect(() => {
        fetchPreData()

        if (order?.customer?.id && order.customer.company && order.paymentCondition?.id === '100') {
            dispatch(fetchAvailableItems({
                paymentConditionId: order.paymentCondition?.id,
                tempItems: selectedOrders?.find(w => w.key === selectItemsState.draftRef).bonificationItems || [],
            })).then((items) => {
                dispatch(updateCampaignItems()).then(() => {
                    setTimeout(() => setLoading(false), 1000)
                })
            })
        }
    }, [order?.customer?.id, order.paymentCondition?.id])

    return (
        <Page
            title={translate('pages.newOrderBonification')}
            greyBackground
            onMenuClick={handleBackToHome}
            menuIcon={<LeftOutlined />}
        >
            <SelectItemsHeader readOnly bonification />
            <Tabs
                defaultActiveKey="bonification"
                style={{ marginLeft: 20 }}
            >
                <TabPane
                    tab={
                        <Row gutter={10}>
                            <Col>{translate('columns.bonification')}</Col>
                            (<Semaphore order={order} moeda={selectedMoeda} loading={loading} />)
                        </Row>
                    }
                    key={'bonification'}
                >
                    <SelectItemsBody bonification />
                </TabPane>
                {selectedOrders?.map((order, index) => {
                    return (
                        <TabPane
                            tab={
                                <Row gutter={10}>
                                    <Col>
                                        {query.get('draftRef') ===
                                            `${order.key}`
                                            ? translate(
                                                'general.actualOrder',
                                            )
                                            : `${translate(
                                                'columns.order',
                                            )} ${order.key}`}
                                    </Col>

                                    <Semaphore
                                        order={order}
                                        moeda={selectedMoeda}
                                    />
                                </Row>
                            }
                            key={`tab-${index + 1}`}
                        >
                            <SelectItemsBodyBonification order={order} />
                        </TabPane>
                    );
                })}
            </Tabs>
            <SelectItemsActions
                bonification
                send={
                    selectedOrders?.find(
                        (w) => `${w.key}` === query.get('draftRef'),
                    )?.orderType?.date
                        ? 0
                        : Number(query.get('draftRef'))
                }
            />
        </Page>
    );
};
